export default {
  COMP: 1,
  CHARGE_CARD: 2,
  CHARGE_DEPT: 3,
  NONE: 4,
};
